import request from "@/utils/request";

export function getListCates(data) {
  return request({ url: "/storeGoods/listCates", method: "post", data: data });
}

export function getListPageCates(params) {
  return request({ url: "/storeGoods/listPageCates", method: "get", params });
}

export function periodGroupByGoodsId(data) {
  return request({
    url: "/storeGoods/periodGroupByGoodsId/",
    method: "post",
    data: data,
  });
}

// export function getPeriodList(data) {
//   return request({ url: "/storeGoods/periods", method: "get", params: data });
// }

export function getDetail(shopId, goodsId) {
  return request({
    url: "/storeGoods/" + goodsId + "/info/" + shopId,
    method: "get",
  });
}
